import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  // side menu
  feedbackButton: {
    id: 'feedbackButton',
    defaultMessage: 'Send feedback',
  },
  appsMenuHeader: {
    id: 'appsMenu.header',
    defaultMessage: 'Product',
  },
  appsMenuMobileHeader: {
    id: 'appsMenu.mobileHeader',
    defaultMessage: 'Switch Product',
  },
  // workspace menu
  workspaceMenuTitle: {
    id: 'workspaceMenu.title',
    defaultMessage: 'Product Environment',
  },
  workspaceMenuHeader: {
    id: 'workspaceMenu.header',
    defaultMessage: 'Product environments',
  },
  workspaceMenuAddNew: {
    id: 'workspaceMenu.addNew',
    defaultMessage: 'Add a new environment',
  },
  workspaceMenuAddEnv: {
    id: 'workspaceMenu.addEnv',
    defaultMessage: 'Add environment',
  },
  workspaceMenuEmptyList: {
    id: 'workspaceMenu.emptyList',
    defaultMessage: "That product environment doesn't exist.",
  },
  workspaceMenuSearchBarPlaceholder: {
    id: 'workspaceMenu.searchBar.placeholder',
    defaultMessage: 'Find environment...',
  },
  workspaceMenuMobileHeader: {
    id: 'workspaceMenu.mobileHeader',
    defaultMessage: 'Product environments',
  },
  // primary menu
  applicationsMenuTooltip: {
    id: 'applications.menuTooltip',
    defaultMessage: 'Products',
  },
  addonsMenuTooltip: {
    id: 'addons.menuTooltip',
    defaultMessage: 'Add-ons',
  },
  addNewUserMenuTooltip: {
    id: 'addNewUser.menuTooltip',
    defaultMessage: 'Invite New Users',
  },
  referFriends: {
    id: 'addons.referFriends',
    defaultMessage: 'Share with a Friend',
  },
  settingsMenuTooltip: {
    id: 'settings.menuTooltip',
    defaultMessage: 'Settings',
  },
  marketplaceMenuTooltip: {
    id: 'marketplace.menuTooltip',
    defaultMessage: 'Add-on Marketplace',
  },
  // share with a friend
  shareWithAFriendModalTitle: {
    id: 'shareWithAFriendModalTitle',
    defaultMessage: 'Share with a friend',
  },
  shareWithAFriendModalContent: {
    id: 'shareWithAFriendModalContent',
    defaultMessage: 'Invite friends, earn credits!',
  },
  shareWithAFriendModalNote: {
    id: 'shareWithAFriendModalNote',
    defaultMessage: 'Get 3 free credits for each friend who signs up, up to 60 credits.',
  },
  // user menu
  userMobileMenuHeader: {
    id: 'user.mobileMenuHeader',
    defaultMessage: 'Profile Settings',
  },
  userSwitchMyAccount: {
    id: 'user.switchMyAccount',
    defaultMessage: 'Switch to my account',
  },
  shareWithAFriend: {
    id: 'user.shareWithAFriend1',
    defaultMessage: 'Share with a friend',
  },
  userSwitchDemoAccount: {
    id: 'user.switchDemoAccount',
    defaultMessage: 'Switch to Demo account',
  },
  userManageAccount: {
    id: 'user.manageAccount',
    defaultMessage: 'Manage account',
  },
  userLogout: {
    id: 'user.logout',
    defaultMessage: 'Log Out',
  },
  userMyProfile: {
    id: 'user.myProfile',
    defaultMessage: 'My Profile',
  },
  // help menu
  helpMenuTooltip: {
    id: 'help.menuTooltip',
    defaultMessage: 'Help',
  },
  helpMobileMenuHeader: {
    id: 'help.mobileMenuHeader',
    defaultMessage: 'Help',
  },
  helpDocumentation: {
    id: 'help.documentation',
    defaultMessage: 'Documentation',
  },
  helpAskAQuestion: {
    id: 'help.askAQuestion',
    defaultMessage: 'Get support',
  },
  helpReleaseNotes: {
    id: 'help.releaseNotes',
    defaultMessage: 'Release notes',
  },
  helpRoadmap: {
    id: 'help.roadmap',
    defaultMessage: 'Roadmap',
  },
  helpBlog: {
    id: 'help.blog',
    defaultMessage: 'Blog',
  },
  helpTrainingCourses: {
    id: 'help.trainingCourses',
    defaultMessage: 'Training courses',
  },
  helpSystemStatus: {
    id: 'help.systemStatus',
    defaultMessage: 'System status',
  },
  productExplorerName: {
    id: 'productList.productExplorer.name',
    defaultMessage: 'Product Explorer',
  },
  productExplorerDescription: {
    id: 'productList.productExplorer.description',
    defaultMessage: 'Product Explorer',
  },
  //products list
  mediaManagementName: {
    id: 'productList.MM.name',
    defaultMessage: 'Media Management API',
  },
  mediaManagementDescription: {
    id: 'productList.MM.description',
    defaultMessage: 'Create personalized media experiences',
  },
  mediaEditingName: {
    id: 'productList.ME.name',
    defaultMessage: 'Media Editing API',
  },
  settingsName: {
    id: 'productList.settings.name',
    defaultMessage: 'Settings',
  },
  settingsDescription: {
    id: 'productList.settings.description',
    defaultMessage: 'Settings application',
  },
  mediaEditingDescription: {
    id: 'productList.ME.description',
    defaultMessage: 'Powerful image and video APIs for editing',
  },
  mediaOptimizerName: {
    id: 'productList.MO.name',
    defaultMessage: 'Media Optimizer',
  },
  mediaOptimizerDescription: {
    id: 'productList.MO.description',
    defaultMessage: 'No code, automated optimization, and delivery',
  },
  digitalAssetManagementName: {
    id: 'productList.DAM.name',
    defaultMessage: 'Assets',
  },
  digitalAssetManagementDescription: {
    id: 'productList.DAM.description',
    defaultMessage: 'DAM for small businesses and teams',
  },
  cloudinaryAssetsName: {
    id: 'productList.CloudinaryAssets.name',
    defaultMessage: 'Assets',
  },
  cloudinaryAssetsDescription: {
    id: 'productList.CloudinaryAssets.description',
    defaultMessage: 'Digital asset management',
  },
  programmableMediaName: {
    id: 'productList.PM.name',
    defaultMessage: 'Programmable Media',
  },
  programmableMediaDescription: {
    id: 'productList.PM.description',
    defaultMessage: 'APIs to automate image and video lifecycles',
  },
  mediaFlowsName: {
    id: 'productList.mediaFlows.name',
    defaultMessage: 'MediaFlows',
  },
  mediaFlowsDescription: {
    id: 'productList.mediaFlows.description',
    defaultMessage: 'Low-code workflow automation for image and video',
  },
  dimensionsName: {
    id: 'productList.dimensions.name',
    defaultMessage: '3D',
  },
  dimensionsDescription: {
    id: 'productList.dimensions.description',
    defaultMessage: 'Content creation and 3D experiences at scale',
  },
  finalTouchName: {
    id: 'productList.finalTouch.name',
    defaultMessage: 'FinalTouch',
  },
  finalTouchDescription: {
    id: 'productList.finalTouch.description',
    defaultMessage: 'AI magic for your product photos',
  },
  videoAppName: {
    id: 'productList.video.name',
    defaultMessage: 'Video',
  },
  videoAppDescription: {
    id: 'productList.video.description',
    defaultMessage: 'Complete solution to manage, transform, and optimize videos',
  },
  productExplorerLink: {
    id: 'productExplorerLink',
    defaultMessage: 'Open Product Explorer',
  },
  // product menu
  betaBadge: {
    id: 'productMenu.betaBadge',
    defaultMessage: 'BETA',
  },
  earlyAccessBadge: {
    id: 'productMenu.earlyAccessBadge',
    defaultMessage: 'EARLY ACCESS',
  },
  moreProductsTooltip: {
    id: 'productMenu.moreProductsTooltip',
    defaultMessage: 'More products',
  },
  // errors
  pleaseRefresh: {
    id: 'pleaseRefresh',
    defaultMessage: 'Please <strong>refresh</strong> to try again.',
  },
  cantAccessYourProducts: {
    id: 'cantAccessYourProducts',
    defaultMessage: 'We can’t access your products',
  },
  invalidCustomerTitle: {
    id: 'invalidCustomerTitle',
    defaultMessage: 'We can’t find the product environment you asked for',
  },
  invalidCustomerAction: {
    id: 'invalidCustomerAction',
    defaultMessage: 'Go to my default environment',
  },
  guestBarLabel: {
    id: 'guestBar.label',
    defaultMessage: 'Guest',
  },
  guestBarTooltipDisplay: {
    id: 'guestBar.tooltip.display',
    defaultMessage: 'Display Customer Images',
  },
  guestBarTooltipHide: {
    id: 'guestBar.tooltip.hide',
    defaultMessage: 'Hide Customer Images',
  },
  noEnvironmentYet: {
    id: 'noEnvironmentYet',
    defaultMessage: 'No Environment yet',
  },
  loginAsConfirmationModalHeader: {
    id: 'loginAs.confirmationModal.header',
    defaultMessage: 'Confirm your login',
  },
  loginAsRenewModalHeader: {
    id: 'loginAs.RenewalModal.header',
    defaultMessage: 'Renew your login',
  },
  loginAsConfirmationModalContent: {
    id: 'loginAs.confirmationModal.content',
    defaultMessage:
      "<p>I understand that I - {userName} - am about to be exposed to this customer's assets and data.</p>" +
      '<p>I confirm that I am accessing this account only to fulfill required work-related tasks.</p>',
  },
  loginAsConfirmationModalConfirmButtonLabel: {
    id: 'loginAs.confirmationModal.confirmButton.label',
    defaultMessage: 'Confirm',
  },
  loginAsConfirmationModalAcceptButtonLabel: {
    id: 'loginAs.confirmationModal.acceptButton.label',
    defaultMessage: 'Accept',
  },
  loginAsConfirmationModalCancelButtonLabel: {
    id: 'loginAs.confirmationModal.cancelButton.label',
    defaultMessage: 'Cancel',
  },
  loginAsDisplayAssetsModalHeader: {
    id: 'loginAs.displayAssets.header',
    defaultMessage: 'Display Customer images',
  },
  loginAsDisplayAssetsModalContentQuestion1: {
    id: 'loginAs.displayAssets.content.question1',
    defaultMessage: 'What is the justification for displaying assets?',
  },
  loginAsDisplayAssetsModalContentPlaceholder: {
    id: 'loginAs.displayAssets.content.placeholder',
    defaultMessage: 'REQUIRED: Provide details, including Zendesk/JIRA ID if relevant, and additional info on why you must display the images.',
  },
  loginAsDisplayAssetsModalContentQuestion1_zendesk: {
    id: 'loginAs.displayAssets.content.question1.zendesk',
    defaultMessage: 'Working on a Zendesk ticket',
  },
  loginAsDisplayAssetsModalContentQuestion1_jira: {
    id: 'loginAs.displayAssets.content.question1.jira',
    defaultMessage: 'Working on a JIRA ticket',
  },
  loginAsDisplayAssetsModalContentQuestion1_session: {
    id: 'loginAs.displayAssets.content.question1.session',
    defaultMessage: 'Preparing to / having a session with the customer',
  },
  loginAsDisplayAssetsModalContentQuestion1_suspicious: {
    id: 'loginAs.displayAssets.content.question1.suspicious',
    defaultMessage: 'Suspicious behavior',
  },
  loginAsDisplayAssetsModalContentQuestion1_other: {
    id: 'loginAs.displayAssets.content.question1.other',
    defaultMessage: 'Other',
  },
  loginAsDisplayAssetsModalSubmitButtonLabel: {
    id: 'loginAs.displayAssets.submitButton.label',
    defaultMessage: 'Submit',
  },
  loginAsDisplayAssetsModalCancelButtonLabel: {
    id: 'loginAs.displayAssets.cancelButton.label',
    defaultMessage: 'Cancel',
  },
  // Environment Creation
  environmentCreationCreatingYourProductEnv: {
    id: 'environmentCreation.creatingYourProduct',
    defaultMessage: 'Preparing your product. Please wait...',
  },
  environmentCreationInitializingYourEnvironment: {
    id: 'environmentCreation.initializingYourEnvironment',
    defaultMessage: 'Initializing your product environment...',
  },
  environmentCreationFinishingUp: {
    id: 'environmentCreation.finishingUp',
    defaultMessage: 'Finishing up...',
  },
  environmentCreationYourProductEnvIsReady: {
    id: 'environmentCreation.yourProductEnvIsReady',
    defaultMessage: 'Your product is ready. Have fun!',
  },
  disabledBadge: {
    id: 'disabledBadge',
    defaultMessage: 'Disabled',
  },
});
